export default "__VITE_ASSET__etnXVL$j__"